var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ColumnMetadata_1;
import '@symon-ai/wisepipe-common-data'; // force import for JsonSchemaV2
import { Column } from '@symon-ai/wisepipe-common-data';
import { JSON, JsonConverter, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import './columnMetadataOriginItem'; // force import for JsonSchemaV2
import { ColumnMetadataOriginItem } from './columnMetadataOriginItem';
import './customFormat'; // force import for JsonSchemaV2
import { columnMetadataSchemaValidation } from '../validations.generated';
export const columnMetadataSchema = {
    $id: 'urn:wisepipe-common-pipe:ColumnMetadata',
    type: 'object',
    properties: {
        column: { $ref: 'urn:wisepipe-common-data:Column' },
        name: { type: 'string' },
        colOrigins: {
            type: 'object',
            additionalProperties: {
                $ref: 'urn:wisepipe-common-pipe:ColumnMetadataOriginItem'
            }
        },
        required: { type: 'boolean' },
        customFormat: { $ref: 'urn:wisepipe-common-pipe:CustomFormat' }
    },
    required: ['column', 'name', 'colOrigins', 'required']
};
// Represents a column in it's current state (column) and the original data source columns that's needed to create it (colOrigins)
let ColumnMetadata = ColumnMetadata_1 = class ColumnMetadata {
    get type() {
        return this.column.type;
    }
    // column: current column definition
    // colOrigins: map of datasourceid->columns that was the origin for this column
    constructor(column, colOrigins, required, customFormat, changed, isNew) {
        this.column = column;
        this.name = column.name;
        this.colOrigins = new Map(colOrigins);
        this.required = required || false; // default to not required\
        this.customFormat = customFormat;
        this.changed = changed;
        this.isNew = isNew;
        JSON.validate(this, ColumnMetadata_1);
    }
    static fromFileColumn(fileID, column) {
        const fileIDToColMap = new Map();
        const colNameToColMap = new ColumnMetadataOriginItem([column]);
        fileIDToColMap.set(fileID, colNameToColMap);
        return new ColumnMetadata_1(column, fileIDToColMap, false);
    }
    // Creates a new columnmetadata, whose colOrigis are the combination of the parents column metadata
    static fromParents(column, parents, required) {
        return new ColumnMetadata_1(column, ColumnMetadata_1.mergeColumnOrigins(parents), required);
    }
    // Merge a list of column metadata origins together, result is
    // key -> fileid
    // value -> colMetatadata origin items
    static mergeColumnOrigins(columnMetadatas) {
        const merged = new Map();
        // 1. go through all metadatas
        // 2. go through all origins
        // 3. merge the origins
        for (const colMet of columnMetadatas) {
            for (const colOrigin of colMet.colOrigins) {
                if (!merged.has(colOrigin[0]))
                    merged.set(colOrigin[0], colOrigin[1]);
                else
                    merged.set(colOrigin[0], ColumnMetadataOriginItem.merge([merged.get(colOrigin[0]), colOrigin[1]]));
            }
        }
        return merged;
    }
    toNewColumnMetadata(required, alias, type, clearCustomFormat = false, customFormat, changed, isNew) {
        const metadata = type && this.column.type !== type ? undefined : this.column.metadata; // only copy metadata if the type is the same
        return new ColumnMetadata_1(new Column(alias || this.name, type || this.type, metadata), this.colOrigins, required || this.required, clearCustomFormat ? undefined : customFormat || this.customFormat, changed, isNew);
    }
    addNewColumnOrigins(dependees) {
        ColumnMetadata_1.mergeColumnOrigins([this, ...dependees]).forEach((val, key) => this.colOrigins.set(key, val));
    }
};
__decorate([
    JsonConverter(new MapConverter(ColumnMetadataOriginItem))
], ColumnMetadata.prototype, "colOrigins", void 0);
ColumnMetadata = ColumnMetadata_1 = __decorate([
    JsonSchemaV2(columnMetadataSchema, columnMetadataSchemaValidation)
], ColumnMetadata);
export { ColumnMetadata };
//# sourceMappingURL=columnMetadata.js.map